import { ReactNode } from "react";

import { IconComponent } from "types/Icon";

import Box from "../Box";
import IconEmphasized from "../IconEmphasized";
import ActionCardWrapper from "./Wrapper";
import ActionCardDescription from "./Description";
import ActionCardTitle from "./Title";
import ActionCardContent from "./Content";
import ActionCardTextWrapper from "./TextWrapper";

type ActionCardProps = {
  title: string;
  titleSuffix?: ReactNode;
  description?: string | ReactNode;
  icon: IconComponent;
  iconVariant?: "primary" | "secondary" | "neutral";
  actionComponent: ReactNode;
  emphasized?: boolean;
  iconBackgroundColor?: string;
};

const ActionCard = ({
  title,
  titleSuffix,
  icon,
  description,
  actionComponent,
  emphasized,
  iconBackgroundColor,
  iconVariant = "secondary",
}: ActionCardProps) => {
  return (
    <ActionCardWrapper emphasized={emphasized}>
      <ActionCardContent>
        <Box justify="between" align="center" gap="medium" fullWidth>
          <IconEmphasized backgroundColor={iconBackgroundColor} icon={icon} variant={iconVariant} />
          <Box>{actionComponent}</Box>
        </Box>

        <ActionCardTextWrapper>
          <ActionCardTitle suffix={titleSuffix}>{title}</ActionCardTitle>

          {description && <ActionCardDescription>{description}</ActionCardDescription>}
        </ActionCardTextWrapper>
      </ActionCardContent>
    </ActionCardWrapper>
  );
};

ActionCard.displayName = "DS.ActionCard";

export default ActionCard;
